import React from "react";
import { observer } from "mobx-react";
import { CollectiveManagementSocietyUpdateStore } from "../../store";
import { CollectiveManagementSocietyUpdateForm } from "./CollectiveManagementSocietyUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type CollectiveManagementSocietyUpdateProps = {
  collectiveManagementSocietyUpdateStore: CollectiveManagementSocietyUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CollectiveManagementSocietyUpdate: React.FC<CollectiveManagementSocietyUpdateProps> =
  observer(
    ({
      collectiveManagementSocietyUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={collectiveManagementSocietyUpdateStore.isSaving}
          />
          <OutdatedAfterSaveNotice
            open={collectiveManagementSocietyUpdateStore.savedButOutdated}
            onReload={() =>
              collectiveManagementSocietyUpdateStore.reloadCollectiveManagementSociety()
            }
            reloadDisabled={collectiveManagementSocietyUpdateStore.isProcessing}
          />
          <CollectiveManagementSocietyUpdateForm
            collectiveManagementSocietyUpdateStore={
              collectiveManagementSocietyUpdateStore
            }
            nameError={
              collectiveManagementSocietyUpdateStore.errors.name?.message
            }
            onNameChange={(value: string) => {
              collectiveManagementSocietyUpdateStore.setNameValue(value);
            }}
            name={collectiveManagementSocietyUpdateStore.entityValues.name}
            acronymError={
              collectiveManagementSocietyUpdateStore.errors.acronym?.message
            }
            onAcronymChange={(value: string) => {
              collectiveManagementSocietyUpdateStore.setAcronymValue(value);
            }}
            acronym={
              collectiveManagementSocietyUpdateStore.entityValues.acronym
            }
            countryError={
              collectiveManagementSocietyUpdateStore.errors.country?.message
            }
            onCountryChange={(value) => {
              collectiveManagementSocietyUpdateStore.setCountryValue(value);
            }}
            countrySelectedValue={
              collectiveManagementSocietyUpdateStore.entityValues.showCountry
            }
            onCountrySelected={(value) => {
              collectiveManagementSocietyUpdateStore.setSelectedCountry(value);
            }}
            countryOptions={collectiveManagementSocietyUpdateStore.getCountryOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={collectiveManagementSocietyUpdateStore.saveDisabled}
            onSave={() =>
              collectiveManagementSocietyUpdateStore.saveCollectiveManagementSociety()
            }
            onCancel={() =>
              collectiveManagementSocietyUpdateStore.cancelCollectiveManagementSociety()
            }
          />
          <ErrorDialog
            open={collectiveManagementSocietyUpdateStore.errorDialogOpened}
            title={collectiveManagementSocietyUpdateStore.errorTitle}
            description={
              collectiveManagementSocietyUpdateStore.errorDescription
            }
            onClose={() =>
              collectiveManagementSocietyUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={collectiveManagementSocietyUpdateStore.confirmDialogOpened}
            title={collectiveManagementSocietyUpdateStore.confirmDialogTitle}
            description={
              collectiveManagementSocietyUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              collectiveManagementSocietyUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              collectiveManagementSocietyUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
